// 客服系统
const WORK_ORDER = {
  // 订单类型
  WORK_ORDER_ORDER_TYPE: {
    1: {
      value: 1,
      desc: '预约一口价',
    },
    4: {
      value: 4,
      desc: '日租/半日租'
    },
    5: {
      value: 5,
      desc: '即时订单'
    },
    16: {
      value: 16,
      desc: '预约实时计价'
    },
  },
  // 下线类型
  WORK_ORDER_OFFLINE_TYPE: {
    0: {
      value: 0,
      desc: '不下线'
    },
    1: {
      value: 1,
      desc: '临时下线'
    },
    2: {
      value: 2,
      desc: '永久下线'
    },
    4: {
      value: 4,
      desc: '派单降级（不下线）'
    },
  },
  // 违规等级
  WORK_ORDER_PUNISH_LABEL: {
    1: {desc: '1', value: 1},
    2: {desc: '2', value: 2},
    3: {desc: '3', value: 3},
    4: {desc: '4', value: 4},
    5: {desc: '5', value: 5},
    6: {desc: '6', value: 6},
    7: {desc: '7', value: 7}
  },
  // 违约标准
  WORK_ORDER_PUNISH_STANDARD: {
    1: {desc: '司机收入', value: 1},
    2: {desc: '违规所得', value: 2},
    3: {desc: '附加费', value: 3},
    4: {desc: '停车费', value: 4},
    5: {desc: '过路费', value: 5},
  }
}

export default WORK_ORDER
